export const insertCourse = (courseId,payload) => {
    
    const currentCourse = payload.filter((course) => course._id == courseId)

    return currentCourse
}